import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useLazyQuery } from '@apollo/client';
import { TimeIcon } from '@chakra-ui/icons';
import { Flex, HStack, IconButton, Input, Modal, ModalBody, ModalContent, ModalOverlay, Text, Tooltip, VStack, useDisclosure, useToast } from '@chakra-ui/react';
import { Button } from '@cofit/components';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import * as R from 'ramda';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useUserDataContextProvider } from 'src/context/UserDataContextProvider';
import useNavigation from 'src/hooks/useNavigation';
import { MenuID } from 'src/types';
import { isClinic as checkIsClinic } from 'src/utils';
import { getConsultationTreatmentWording } from 'src/utils/wording';
import { escapeSQLChars, getSearchPhoneString, isShowOriginalPhone, normalizePhone } from '../../../src/utils';
import { SearchQueryGQL } from '../../api/SearchQueryAPI';
import { BranchConstants } from '../../constants';
import dataTestID from '../../constants/DataTestIndex';
import EnterButton from '../Button/EnterButton';
import EditableAppointmentRecordModal from '../EditableAppointmentRecordModal';
import Loading from '../Loading';
import { renderTooltipCell } from '../Table/TableCell';
import { TableContent } from '../Table/TableContent_v8';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var columns = function columns(_ref) {
  var t = _ref.t,
      can = _ref.can,
      handleRecordButtonClick = _ref.handleRecordButtonClick;
  return [{
    header: t('common:normal.client_name', '客戶姓名'),
    accessorKey: 'real_name',
    width: '20%',
    cell: renderTooltipCell
  }, {
    header: t('client:normal.boundMobile', '綁定電話'),
    accessorKey: 'mobile',
    width: '20%',
    cell: function cell(props) {
      return /*#__PURE__*/_jsx(PhoneItem, _objectSpread(_objectSpread({}, props), {}, {
        e2eid: "Header_SearchBar_PhoneItem"
      }));
    }
  }, {
    header: t('common:normal.record_number', '病歷號碼'),
    accessorKey: 'record_number',
    width: '20%'
  }, {
    header: t('common:normal.identityNumber', '身分證字號'),
    accessorKey: 'identity_number',
    width: '20%'
  }, {
    header: t(getConsultationTreatmentWording('soapRecordText'), '諮詢診療'),
    accessorKey: 'editable',
    width: '20%',
    cell: function cell(props) {
      var _props$row;

      return /*#__PURE__*/_jsxs(HStack, {
        e2eid: "Header_SearchBar_HStack",
        children: [checkIsClinic() && can({
          type: 'action',
          subject: 'client_appointment_records',
          action: 'enter'
        }) && /*#__PURE__*/_jsx(RecordButton, {
          handleClick: handleRecordButtonClick(props === null || props === void 0 ? void 0 : (_props$row = props.row) === null || _props$row === void 0 ? void 0 : _props$row.original),
          e2eid: "Header_SearchBar_RecordButton"
        }), can({
          type: 'action',
          subject: 'client_profile',
          action: 'enter'
        }) && /*#__PURE__*/_jsx(Editable, _objectSpread(_objectSpread({}, props), {}, {
          e2eid: "Header_SearchBar_Editable"
        }))]
      });
    }
  }];
};

var RecordButton = function RecordButton(_ref2) {
  var handleClick = _ref2.handleClick;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Tooltip, {
    label: t('client:normal.appointmentProcess', '預約歷程'),
    placement: "left",
    e2eid: "Header_SearchBar_Tooltip",
    children: /*#__PURE__*/_jsx(IconButton, {
      "aria-label": "View Appointment Record",
      icon: /*#__PURE__*/_jsx(TimeIcon, {
        boxSize: 4,
        e2eid: "Header_SearchBar_TimeIcon"
      }),
      size: "sm",
      colorScheme: "gray",
      onClick: handleClick,
      e2eid: "Header_SearchBar_IconButton"
    })
  });
};

var Editable = function Editable(_ref3) {
  var row = _ref3.row;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  var _useNavigation = useNavigation(),
      navigate = _useNavigation.navigate;

  if (!row.original) return null;

  var _ref4 = row !== null && row !== void 0 ? row : {},
      original = _ref4.original;

  var _ref5 = original !== null && original !== void 0 ? original : {},
      client_id = _ref5.client_id;

  var handleClick = function handleClick() {
    navigate(MenuID.client, {
      clientID: client_id
    }, {
      newTab: true
    });
  };

  return /*#__PURE__*/_jsx(EnterButton, {
    size: "sm",
    w: "72px",
    handleClick: handleClick,
    e2eid: "Header_SearchBar_EnterButton",
    children: t('common:button.enter', '進入')
  });
};

var PhoneItem = function PhoneItem(_ref6) {
  var getValue = _ref6.getValue;

  var _useUserDataContextPr = useUserDataContextProvider(),
      can = _useUserDataContextPr.can;

  var phone = getValue();
  var toShowOriginalPhone = isShowOriginalPhone(can);
  return /*#__PURE__*/_jsx("p", {
    e2eid: "Header_SearchBar_p",
    children: toShowOriginalPhone ? phone : normalizePhone(phone)
  });
};

var EMPTY_SEARCH_TOAST_ID = 'emptySearchToast';
export var SearchBar = function SearchBar() {
  var _useTranslation3 = useTranslation(),
      t = _useTranslation3.t;

  var _useState = useState(''),
      searchTxt = _useState[0],
      setSearchTxt = _useState[1];

  var _useState2 = useState(),
      selectedClient = _useState2[0],
      setSelectedClient = _useState2[1];

  var _useLazyQuery = useLazyQuery(SearchQueryGQL),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      mutateFunction = _useLazyQuery2[0],
      _useLazyQuery2$ = _useLazyQuery2[1],
      data = _useLazyQuery2$.data,
      loading = _useLazyQuery2$.loading;

  var _useDisclosure = useDisclosure(),
      isSearchResultModalOpen = _useDisclosure.isOpen,
      onSearchResultModalOpen = _useDisclosure.onOpen,
      onSearchResultModalClose = _useDisclosure.onClose;

  var _useDisclosure2 = useDisclosure(),
      isEditableAppointmentRecordModalOpen = _useDisclosure2.isOpen,
      onEditableAppointmentRecordModalOpen = _useDisclosure2.onOpen,
      onEditableAppointmentRecordModalClose = _useDisclosure2.onClose;

  var toast = useToast();

  var _useUserDataContextPr2 = useUserDataContextProvider(),
      can = _useUserDataContextPr2.can;

  var _useRouter = useRouter(),
      pathname = _useRouter.pathname;

  var hideSearchbar = pathname === MenuID.deliverynote;
  var handleSearch = useCallback(function () {
    if (!searchTxt) {
      if (!toast.isActive(EMPTY_SEARCH_TOAST_ID)) {
        toast({
          id: EMPTY_SEARCH_TOAST_ID,
          title: t('common:form.searchInputRequiredWarning', '請輸入搜尋條件'),
          status: 'error',
          duration: 1000,
          isClosable: true,
          position: 'top'
        });
      }

      return;
    }

    var safeSearchTxt = escapeSQLChars(searchTxt);
    mutateFunction({
      variables: {
        text: '%' + safeSearchTxt + '%',
        mobile: getSearchPhoneString(safeSearchTxt),
        branch_id: BranchConstants.BRANCH_ID
      }
    });
    onSearchResultModalOpen();
  }, [searchTxt, toast, t, mutateFunction, onSearchResultModalOpen]);
  var handleRecordButtonClick = useCallback(function (client) {
    return function () {
      setSelectedClient(client);
      onSearchResultModalClose();
      onEditableAppointmentRecordModalOpen();
    };
  }, [onEditableAppointmentRecordModalOpen, onSearchResultModalClose]);
  var handleEditableAppointmentRecordModalClose = useCallback(function () {
    onEditableAppointmentRecordModalClose();
    onSearchResultModalOpen();
  }, [onEditableAppointmentRecordModalClose, onSearchResultModalOpen]);
  var cols = useMemo(function () {
    return columns({
      t: t,
      can: can,
      handleRecordButtonClick: handleRecordButtonClick
    });
  }, [t, can, handleRecordButtonClick]);
  var searchResult = useMemo(function () {
    return R.pipe(R.propOr([], 'clients'), R.map(function (client) {
      return {
        mobile: R.pathOr(R.pathOr(R.propOr('', 'mobile', client), ['org_client_profiles', 0, 'mobile'], client), ['identities', 0, 'uid'], client),
        birthday: R.pathOr(R.prop('birthday', client), ['org_client_profiles', 0, 'birthday'], client),
        real_name: R.pathOr(R.prop('real_name', client), ['org_client_profiles', 0, 'real_name'], client),
        gender: R.pathOr(R.prop('gender', client), ['org_client_profiles', 0, 'gender'], client),
        name: R.pathOr(R.prop('name', client), ['org_client_profiles', 0, 'name'], client),
        record_number: R.pathOr('', ['org_client_profiles', 0, 'record_number'], client),
        identity_number: R.pathOr('', ['org_client_profiles', 0, 'identity_number'], client),
        client_id: R.pathOr('', ['org_client_profiles', 0, 'client_id'], client)
      };
    }))(data);
  }, [data]);
  useEffect(function () {
    if (hideSearchbar) {
      setSearchTxt('');
    }
  }, [hideSearchbar]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Modal, {
      isOpen: isSearchResultModalOpen,
      onClose: onSearchResultModalClose,
      isCentered: true,
      e2eid: "Header_SearchBar_Modal",
      children: [/*#__PURE__*/_jsx(ModalOverlay, {
        e2eid: "Header_SearchBar_ModalOverlay"
      }), /*#__PURE__*/_jsx(ModalContent, {
        maxW: "70vw",
        e2eid: "Header_SearchBar_ModalContent",
        children: /*#__PURE__*/_jsx(ModalBody, {
          "data-test": dataTestID.booking.SearchResultModal,
          e2eid: "Header_SearchBar_ModalBody",
          children: loading ? /*#__PURE__*/_jsx(Loading, {
            e2eid: "Header_SearchBar_Loading"
          }) : (searchResult === null || searchResult === void 0 ? void 0 : searchResult.length) > 0 ? /*#__PURE__*/_jsxs(VStack, {
            e2eid: "Header_SearchBar_VStack",
            children: [/*#__PURE__*/_jsx(Text, {
              "data-test": dataTestID.booking.SearchResultTitle,
              fontSize: 16,
              fontWeight: "bold",
              textAlign: "left",
              w: "full",
              e2eid: "Header_SearchBar_Text",
              children: t('common:normal.searchResult', '搜尋結果')
            }), /*#__PURE__*/_jsx(TableContent, {
              showTotalAmount: true,
              tableLayout: "fixed",
              data: searchResult,
              columns: cols,
              maxH: "80vh",
              e2eid: "Header_SearchBar_TableContent"
            })]
          }) : /*#__PURE__*/_jsxs(VStack, {
            py: 2,
            alignItems: "flex-start",
            e2eid: "Header_SearchBar_VStack",
            children: [/*#__PURE__*/_jsxs(Text, {
              e2eid: "Header_SearchBar_Text",
              children: [t('common:button.search', '搜尋'), "\uFF1A\"", searchTxt, "\""]
            }), /*#__PURE__*/_jsx(Text, {
              e2eid: "Header_SearchBar_Text_19",
              children: t('common:normal.noSearchResult', '查無相關病歷檔案，請確認您搜尋的學員是否有在此系統建立病歷號碼')
            })]
          })
        })
      })]
    }), isEditableAppointmentRecordModalOpen && /*#__PURE__*/_jsx(EditableAppointmentRecordModal, {
      client: selectedClient,
      onClose: handleEditableAppointmentRecordModalClose,
      e2eid: "Header_SearchBar_EditableAppointmentRecordModal"
    }), /*#__PURE__*/_jsx(HStack, {
      spacing: "4",
      px: "2",
      bgColor: "white",
      e2eid: "Header_SearchBar_HStack",
      children: /*#__PURE__*/_jsx(Flex, {
        direction: "row",
        borderWidth: 1,
        borderColor: "gray.200",
        rounded: 10,
        ml: 5,
        e2eid: "Header_SearchBar_Flex",
        children: !hideSearchbar && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Input, {
            value: searchTxt,
            onChange: function onChange(e) {
              setSearchTxt(e.target.value);
            },
            "data-test": dataTestID.booking.SearchInput,
            roundedRight: 0,
            placeholder: t('common:normal.PatientFileSearching', '病歷檔案搜尋 (病歷號碼、姓名、電話)'),
            w: 300,
            border: 0,
            onKeyDown: function onKeyDown(e) {
              if (e.key === 'Enter' && !e.nativeEvent.isComposing && !e.repeat) {
                handleSearch();
              }
            },
            e2eid: "Header_SearchBar_Input"
          }), /*#__PURE__*/_jsx(Button, {
            "data-test": dataTestID.booking.SearchButton,
            onClick: handleSearch,
            roundedLeft: 0,
            e2eid: "Header_SearchBar_Button",
            children: t('common:button.search', '搜尋')
          })]
        })
      })
    })]
  });
};